<ng-container *ngIf="pendingFileUrl">
  <bom-alert
    [showIcon]="true"
    [titleKey]="'RedirectingToFile.Title'"
    [descriptionHtml]="'RedirectingToFile.Description' | tekstresource: { url: pendingFileUrl }"
  >
  </bom-alert>
</ng-container>
<ng-container *ngIf="!pendingFileUrl">
  <bom-workspace [titleKey]="'Fuldmagt.SkiftBruger'" descriptionKey="Fuldmagt.Beskrivelse">
    <button class="button button-primary" (click)="continueAsUser(null)">
      {{ 'Fuldmagt.FortsaetSomDigSelv' | tekstresource }}
    </button>
    <bom-spinner *ngIf="isLoading" [message]="'Henter fuldmagter..'"></bom-spinner>
    <ng-container *ngIf="fuldmagtGivere">
      <h4>{{ 'Fuldmagt.FortsaetSom' | tekstresource }}</h4>
      <div class="my-5" *ngFor="let fuldmagtGiver of fuldmagtGivere">
        <button class="button button-secondary" (click)="continueAsUser(fuldmagtGiver)">
          {{ fuldmagtGiver.navn ? fuldmagtGiver.navn : fuldmagtGiver.truncatedCPR }}
        </button>
      </div>
    </ng-container>

    <bom-full-page [show]="openDialog$ | async" [focusTrapping$]="trapping$">
      <ng-container bom-fullpage-main>
        <ng-container>
          <div class="mt-3 mb-6">
            {{ 'Fuldmagt.SkiftBruger.ChooseBeforeContinue' | tekstresource }}
          </div>
        </ng-container>
        <ng-container>
          <button
            class="button button-primary"
            [attr.aria-label]="'_Ok' | tekstresource"
            (click)="closeDialog()"
          >
            {{ '_Ok' | tekstresource }}
          </button>
        </ng-container>
      </ng-container>
    </bom-full-page>
  </bom-workspace>
</ng-container>
